import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { createPreContract } from '../../store/contract.reducer'
import { selectPreContract, selectPreContractBody } from '../../store/contract.selectors'

import {
  PRECONTRACT_SUCCESS,
  PRECONTRACT_ERROR,
  PRECONTRACT_LOADING,
} from '~/modal/constants/messages'
import useModal from '~/modal/hooks/useModal'
import ModalMessages from '~/modal/models/modal.model'
import PATHS from '~/router/paths'
import { selectTheme } from '~/ui/theme/store/theme.selectors'

export default function usePreContract(shouldCreatePreContract: boolean) {
  const history = useHistory()
  const dispatch = useDispatch()
  const brand = useSelector(selectTheme)
  const { httpStatus } = useSelector(selectPreContract)
  const preContractBody = useSelector(selectPreContractBody)
  const { selectAndOpenModalFromList } = useModal()

  function navigateToCheckoutPage() {
    history.push({ pathname: PATHS.CHECKOUT })
  }

  const preContractModalMessages: ModalMessages = {
    PRECONTRACT_SUCCESS: {
      open: false,
      title: PRECONTRACT_SUCCESS.title,
      actions: [
        {
          button: { variant: 'contained', size: 'medium', color: 'secondary' },
          name: PRECONTRACT_SUCCESS.actions.continue,
          fn: () => navigateToCheckoutPage(),
          dataHook: 'confirm-precontract',
        },
      ],
      type: 'success',
      onClose: () => navigateToCheckoutPage(),
    },
    PRECONTRACT_ERROR: {
      open: false,
      title: PRECONTRACT_ERROR.title,
      actions: [
        {
          button: { variant: 'contained', size: 'medium', color: 'secondary' },
          name: PRECONTRACT_ERROR.actions.continue,
          fn: () => navigateToCheckoutPage(),
          dataHook: 'confirm-precontract',
        },
      ],
      type: 'error',
      onClose: () => navigateToCheckoutPage(),
    },
    PRECONTRACT_LOADING: {
      open: false,
      title: PRECONTRACT_LOADING.title,
      description: PRECONTRACT_LOADING.description,
      actions: [],
      type: 'loading',
    },
  }

  useEffect(() => {
    if (shouldCreatePreContract) {
      selectAndOpenModalFromList('PRECONTRACT_LOADING', preContractModalMessages)
      dispatch(createPreContract({ body: preContractBody, tenant: brand }))
    }
  }, [shouldCreatePreContract])

  useEffect(() => {
    if (httpStatus && httpStatus === 204)
      selectAndOpenModalFromList('PRECONTRACT_SUCCESS', preContractModalMessages)
    if (httpStatus && httpStatus !== 204)
      selectAndOpenModalFromList('PRECONTRACT_ERROR', preContractModalMessages)
  }, [httpStatus])
}
